import { IconProps } from "./types";

export const IconlyBuildingOffice = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 20.9107H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3405 20.9103V5.12287C17.3405 3.99908 16.4298 3.08838 15.307 3.08838H8.69464C7.57086 3.08838 6.66016 3.99908 6.66016 5.12287V20.9103"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6736 13.7769L13.6755 13.7869M10.3252 13.7769L10.3271 13.7869"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6736 10.4834L13.6755 10.4934M10.3252 10.4834L10.3271 10.4934"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6736 7.11621L13.6755 7.12621M10.3252 7.11621L10.3271 7.12621"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.97998 20.9109V18.3033C9.97998 17.881 10.3273 17.5337 10.7496 17.5337H13.254C13.6753 17.5337 14.0227 17.881 14.0227 18.3033V20.9109"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3398 9.00781H18.5969C19.385 9.00781 20.0321 9.64608 20.0321 10.4429V20.9112"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08496 20.9112V10.4429C4.08496 9.64608 4.73199 9.00781 5.5201 9.00781H6.65458"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
